import { Icon } from '@landing/icons/Icons';
import { u } from '@landing/base';
import styles from './ProductPreview.module.css';

type Props = { scenario: string; title: string };
const photo = u('/assets/landing/aura-feed-photo.webp');
const people = ['Аня', 'Марк', 'Лиза', 'Даша', 'Макс'];

function Avatar({ index = 0, name = 'А' }: { index?: number; name?: string }) {
  return (
    <span className={styles.avatar} data-tone={index % 5}>
      {name.slice(0, 1)}
    </span>
  );
}

function Feed() {
  return (
    <>
      <div className={styles.stories}>
        {people.map((name, index) => (
          <span key={name}>
            <i>
              <Avatar index={index} name={name} />
            </i>
            <small>{name}</small>
          </span>
        ))}
      </div>
      <div className={styles.author}>
        <Avatar name="А" />
        <span>
          <b>Анна</b>
          <small>Сегодня, 09:12</small>
        </span>
        <span className={styles.more}>···</span>
      </div>
      <img
        className={styles.postPhoto}
        src={photo}
        width="1536"
        height="1024"
        alt=""
        loading="lazy"
      />
      <div className={styles.postActions}>
        <Icon name="heart" />
        <Icon name="chat" />
        <Icon name="share" />
        <span>♡</span>
      </div>
      <p className={styles.caption}>
        <b>Анна</b> Иногда всё, что нужно, — увидеть что-то прекрасное. ☁
      </p>
      <p className={styles.comments}>Посмотреть комментарии</p>
      <div className={styles.event}>
        <span>
          22<small>АВГ</small>
        </span>
        <div>
          <b>Встречаем рассвет</b>
          <small>Хорошая компания. Новый день.</small>
        </div>
        <Icon name="chevron" />
      </div>
    </>
  );
}

function People() {
  return (
    <>
      <p className={styles.intro}>Новые знакомства. Общие интересы.</p>
      <div className={styles.peopleGrid}>
        {people.slice(0, 4).map((name, i) => (
          <div key={name}>
            <Avatar index={i} name={name} />
            <b>{name}</b>
            <small>
              {
                [
                  'Фото · Путешествия',
                  'Музыка · Кино',
                  'Дизайн · Книги',
                  'Спорт · Природа',
                ][i]
              }
            </small>
            <span>Познакомиться ↗</span>
          </div>
        ))}
      </div>
      <div className={styles.note}>
        <Icon name="people" />
        <b>Ваши люди — уже рядом</b>
      </div>
    </>
  );
}

function Shop() {
  return (
    <>
      <div className={styles.chips}>
        <b>Для вас</b>
        <span>Товары</span>
        <span>Услуги</span>
      </div>
      <div className={styles.shopGrid}>
        {[
          ['Наушники', 'Музыка с собой', 'live'],
          ['Фотоаппарат', 'Сохраняйте моменты', 'feed'],
          ['Велосипед', 'Навстречу новому', 'wave'],
          ['Дизайн', 'Найдите своего мастера', 'grid'],
        ].map(([title, subtitle, icon], i) => (
          <div key={title}>
            <span className={styles.itemPhoto} data-tone={i}>
              <Icon name={icon} />
            </span>
            <b>{title}</b>
            <small>{subtitle}</small>
          </div>
        ))}
      </div>
      <div className={styles.note}>
        <Icon name="shield" />
        <b>Профиль продавца всегда рядом</b>
      </div>
    </>
  );
}

function Chat() {
  return (
    <>
      <div className={styles.search}>⌕ Поиск по сообщениям</div>
      {people.slice(0, 4).map((name, i) => (
        <div className={styles.chatRow} key={name}>
          <Avatar name={name} index={i} />
          <div>
            <b>{name}</b>
            <small>
              {
                [
                  'Как насчёт встречи?',
                  'Отправила тебе фото ☁',
                  'Спасибо! Очень красиво',
                  'Голосовое сообщение',
                ][i]
              }
            </small>
          </div>
          <span>{['12:04', '11:58', '10:32', 'Вчера'][i]}</span>
        </div>
      ))}
      <div className={styles.chatBubble}>Давайте соберёмся на выходных?</div>
      <div className={styles.chatReply}>Отличная идея. Я с вами! ✨</div>
    </>
  );
}

function Profile() {
  return (
    <>
      <div className={styles.profileCover}>
        <img src={photo} alt="" loading="lazy" width="1536" height="1024" />
      </div>
      <div className={styles.profile}>
        <Avatar name="А" />
        <h3>Анна</h3>
        <small>@anna · Делюсь тем, что вдохновляет</small>
        <div className={styles.chips}>
          <span>Фотография</span>
          <span>Путешествия</span>
        </div>
      </div>
      <div className={styles.profileLinks}>
        {[
          ['feed', 'Мои публикации'],
          ['people', 'Друзья и подписки'],
          ['shop', 'Мои объявления'],
          ['shield', 'Настройки профиля'],
        ].map(([icon, text]) => (
          <div key={text}>
            <Icon name={icon} />
            <b>{text}</b>
            <Icon name="chevron" />
          </div>
        ))}
      </div>
    </>
  );
}

/** Вёрстанная иллюстрация интерфейса: текст и вкладки остаются чёткими при масштабировании. */
export function ProductPreview({ scenario, title }: Props) {
  return (
    <div
      className={styles.phone}
      aria-label={`Иллюстрация экрана «${title}»`}
      role="img"
    >
      <div className={styles.screen} aria-hidden="true">
        <div className={styles.status}>
          <b>9:41</b>
          <i />
          <span>▮▮▮ ▰</span>
        </div>
        <div className={styles.header}>
          <b>{title}</b>
          <Icon name={scenario === 'chat' ? 'plus' : 'search'} />
        </div>
        <div className={styles.content} key={scenario}>
          {scenario === 'feed' && <Feed />}
          {scenario === 'people' && <People />}
          {scenario === 'shop' && <Shop />}
          {scenario === 'chat' && <Chat />}
          {scenario === 'profile' && <Profile />}
        </div>
        <div className={styles.nav}>
          {['feed', 'people', 'shop', 'chat', 'profile'].map((name) => (
            <span key={name} data-active={scenario === name}>
              <Icon name={name === 'profile' ? 'space' : name} />
            </span>
          ))}
        </div>
        <span className={styles.home} />
      </div>
    </div>
  );
}
